import { GET_KYC_DETAILS, GET_KYC_DETAILS_SUCCESS, GET_KYC_DETAILS_FAILURE } from "../actionTypes";

export const getKycDetails = (payload) => ({
  type: GET_KYC_DETAILS,
  payload,
});

export const getKycDetailsSuccess = (payload) => ({
  type: GET_KYC_DETAILS_SUCCESS,
  payload,
});

export const getKycDetailsFailure = () => ({
  type: GET_KYC_DETAILS_FAILURE,
});
